import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, ERROR_TEXT } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Skeleton } from "@/components/hm/Basics";
import ModuleMedia, { useTimeTracker } from "@/screens/module/Media";
import { ReadProgress, Paywall, ClarityMoment, DoneCard, groupSentences } from "@/screens/module/Parts";

export default function ModuleReader() {
  const { id } = useParams();
  const { refresh } = useAuth();
  const [m, setM] = useState(null);
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);
  useTimeTracker(m && !m.locked ? m.id : null);

  useEffect(() => {
    setM(null); setDone(false); setError(false);
    window.scrollTo(0, 0);
    api.get(`/modules/${id}`).then((r) => setM(r.data)).catch((e) => setError(e?.response?.status === 404 ? "missing" : true));
  }, [id]);

  if (error === "missing") return (
    <div className="reader" data-testid="module-missing">
      <p className="text-muted">Este módulo ya no está disponible.</p>
      <Link to="/academia" className="btn btn-ghost" data-testid="module-missing-back">Volver a Academia</Link>
    </div>
  );
  if (error) return <p className="text-danger" data-testid="module-error">{ERROR_TEXT}</p>;
  if (!m) return <div className="reader"><Skeleton h={60} n={4} /></div>;

  return (
    <article className="reader" data-testid="module-page">
      <ReadProgress />
      <span className="eyebrow">{m.number === 1 ? "Módulo de bienvenida" : `Módulo ${m.number}`} · {m.duration}</span>
      <h3 data-testid="module-title">{m.title}</h3>
      {m.locked ? <Paywall m={m} /> : (
        <>
          <ModuleMedia items={m.media} />
          {m.sections.map((s, i) => (
            <section key={s.title} className="reader-sec" data-testid={`module-section-${i}`}>
              <h4>{s.title}</h4>
              {groupSentences(s.body).map((p) => <p key={p}>{p}</p>)}
            </section>
          ))}
          {done ? <DoneCard m={m} nextId={m.next_id} /> : <ClarityMoment m={m} onDone={() => { setDone(true); refresh(); }} />}
        </>
      )}
    </article>
  );
}
